import { useRouter } from 'next/router';
import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
export default function AuthGuard({
  children
}) {
  const router = useRouter();
  const [isAuthenticated, setIsAuthenticated] = useState(null);
  const authData = useSelector(store => store.auth)?.auth;
  useEffect(() => {
    if (typeof window === 'undefined') return;
    const isLoggedIn = !!authData?.uid;
    setIsAuthenticated(isLoggedIn);
    if (!isLoggedIn) {
      router.push('/auth/signin');
    }
  }, [authData, router]);
  if (isAuthenticated === null) {
    return null;
  }
  if (!isAuthenticated) {
    return null;
  }
  return children;
}
AuthGuard.propTypes = {
  children: PropTypes.node.isRequired
};